import { render, staticRenderFns } from "./RollCallTeacher.vue?vue&type=template&id=f68084cc&scoped=true&"
import script from "./RollCallTeacher.vue?vue&type=script&lang=js&"
export * from "./RollCallTeacher.vue?vue&type=script&lang=js&"
import style0 from "./RollCallTeacher.vue?vue&type=style&index=0&id=f68084cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68084cc",
  null
  
)

export default component.exports